import CardProperty from './CardProperty'
export default CardProperty
